import { useRef, useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

const HOVER_DELAY_TIME = 300;
const CLOSE_DELAY_TIME = 400;

export const useMultiHoverPopupCard = (): {
	isOpen: boolean;
	onMouseEnter: () => void;
	onMouseLeave: () => void;
	onMouseEnterIcon: () => void;
	onMouseLeaveIcon: () => void;
} => {
	const [isOpen, setIsOpen] = useState(false);
	const isMouseInsideRef = useRef(false);

	const onMouseLeaveDebounce = debounce(() => {
		if (!isMouseInsideRef.current) {
			setIsOpen(false);
		}
	}, CLOSE_DELAY_TIME);

	const onMouseEnterDebounce = debounce(() => {
		if (isMouseInsideRef.current) {
			setIsOpen(true);
		}
	}, HOVER_DELAY_TIME);

	const onMouseEnter = (): void => {
		isMouseInsideRef.current = true;
		onMouseEnterDebounce();
	};

	const onMouseLeave = (): void => {
		isMouseInsideRef.current = false;
		onMouseLeaveDebounce();
	};

	const onMouseEnterIcon = (): void => {
		isMouseInsideRef.current = false;
		setIsOpen(false);
	};

	const onMouseLeaveIcon = (): void => {
		isMouseInsideRef.current = true;
		setIsOpen(true);
	};

	useEffect(() => {
		return () => {
			onMouseLeaveDebounce.cancel();
		};
	}, [onMouseLeaveDebounce]);

	return {
		isOpen,
		onMouseEnter,
		onMouseLeave,
		onMouseEnterIcon,
		onMouseLeaveIcon,
	};
};
